import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ─── NASP REPORTING ───────────────────────────────────────────────────────────

// POST api/NaspReporting/ImportFile?userId=...&report=...
// multipart/form-data with a single `file` field.
// `report` is 'ThreeMonthComparison' or 'Cancellations'.
export const NaspReportingImportFileRequest = (userId, report, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}NaspReporting/ImportFile`,
		params: { userId, report },
		data: formData,
		hasLoading: true,
	});
};

// GET api/NaspReporting/GetLastResult?userId=...&report=...
// Same processing as ImportFile but without an input file — answers with the
// path of the generated file.
export const NaspReportingGetLastResultRequest = (userId, report) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspReporting/GetLastResult`,
	params: { userId, report },
	hasLoading: true,
});

// POST api/NaspReporting/SendEmail?userId=...&userEmail=...&report=...&isTest=...
// Sends the report by email. Only used by the Cancellations card.
// isTest true → test recipients (userEmail); false → client distribution list.
export const NaspReportingSendEmailRequest = (userId, userEmail, report, isTest) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}NaspReporting/SendEmail`,
	params: { userId, userEmail, report, isTest },
	hasLoading: true,
});

// GET api/NaspReporting/GetLastUpdate
// → { threeMonthComparison: { insertUser, insertDate }, cancellations: { … } }
export const NaspReportingGetLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspReporting/GetLastUpdate`,
	hasLoading: true,
});
